/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_CountryInputs */

const en_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Country`)
};

const es_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar País`)
};

const fr_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner le Pays`)
};

const de_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land auswählen`)
};

const ja_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国を選択`)
};

const zh_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择国家`)
};

const ar_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر الدولة`)
};

const id_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih Negara`)
};

const it_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona Paese`)
};

const ru_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите Страну`)
};

const pt_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar País`)
};

const ko_select_country = /** @type {(inputs: Select_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`국가 선택`)
};

/**
* | output |
* | --- |
* | "Select Country" |
*
* @param {Select_CountryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const select_country = /** @type {((inputs?: Select_CountryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_CountryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_country(inputs)
	if (locale === "es") return es_select_country(inputs)
	if (locale === "fr") return fr_select_country(inputs)
	if (locale === "de") return de_select_country(inputs)
	if (locale === "ja") return ja_select_country(inputs)
	if (locale === "zh") return zh_select_country(inputs)
	if (locale === "ar") return ar_select_country(inputs)
	if (locale === "id") return id_select_country(inputs)
	if (locale === "it") return it_select_country(inputs)
	if (locale === "ru") return ru_select_country(inputs)
	if (locale === "pt") return pt_select_country(inputs)
	return ko_select_country(inputs)
});